import React, { useState } from "react";
import { Avatar, IconButton } from "@material-ui/core";
import {
  AttachFile,
  MoreVert,
  SearchOutlined,
  InsertEmoticon,
  Mic,
} from "@material-ui/icons";
import "./Chat.css";
import axios from "./axios";

const Chat = ({ messages }) => {
  const [input, setInput] = useState("");

  const sendMessage = async (e) => {
    // stopping from refreshing
    e.preventDefault();

    const d = new Date();
    const timestamp = `${d.getHours()}:${d.getMinutes()}`;

    await axios.post("/messages/new", {
      message: input,
      name: "DEMO USER",
      timestamp: timestamp,
      received: true,
    });

    setInput("");
  };

  return (
    <div className="chat">
      <div className="chat__header">
        <Avatar />

        <div className="chat__headerInfo">
          <h3>Room name</h3>
          <p>Last seen at...</p>
        </div>

        <div className="chat__headerRight">
          <IconButton>
            <SearchOutlined />
          </IconButton>
          <IconButton>
            <AttachFile />
          </IconButton>
          <IconButton>
            <MoreVert />
          </IconButton>
        </div>
      </div>

      <div className="chat__body">
        {messages?.map((message) => {
          return (
            <p
              className={`chat__message ${
                message.received && "chat__receiver"
              }`}
              key={message._id}
            >
              <span className="chat__name">{message.name}</span>
              {message.message}
              <span className="chat__timestamp">{message.timestamp}</span>
            </p>
          );
        })}
      </div>

      <div className="chat__footer">
        {/* <IconButton> */}
        <InsertEmoticon />
        {/* </IconButton> */}
        <form>
          <input
            value={input}
            onChange={(text) => setInput(text.target.value)}
            type="text"
            placeholder="Type a message"
          />
          <button onClick={sendMessage} type="submit">
            Send a message
          </button>
        </form>
        {/* <IconButton> */}
        <Mic />
        {/* </IconButton> */}
      </div>
    </div>
  );
};

export default Chat;
